module.exports = new __parcel__URL__("Shamanskill_34.5e496bb5.png").toString();